var _path, _rect, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _rect4, _circle, _rect5, _rect6, _rect7, _path7, _rect8, _path8, _path9, _path10, _path11, _path12, _rect9, _rect10, _rect11, _path13, _rect12, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon, _path22, _polygon2, _path23, _path24, _circle2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 883,
    height: 800.8561,
    viewBox: "0 0 883 800.8561",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M441.4998,285.8561H441.5A122.49988,122.49988,0,0,1,563.99993,408.356V701.8561a0,0,0,0,1,0,0h-245a0,0,0,0,1,0,0V408.356A122.49988,122.49988,0,0,1,441.4998,285.8561Z",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 376.99993,
    y: 433.13421,
    width: 22,
    height: 73,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 404.99993,
    y: 512.13421,
    width: 73,
    height: 65.99945,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 404.99993,
    y: 433.13421,
    width: 73,
    height: 73,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M642.49993,476.70616h22v-1.50061a64.329,64.329,0,0,0-22-48.49628Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M563.49993,476.70616h73V422.03221a64.18843,64.18843,0,0,0-36.5-11.3266h0a64.18848,64.18848,0,0,0-36.5,11.32666Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M557.49993,561.70616h-22v49.99945a16.00008,16.00008,0,0,0,16,16h6Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M642.49993,561.70616v65.99945h6a16.00009,16.00009,0,0,0,16-16V561.70616Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M557.49993,476.70616V426.70933a64.32884,64.32884,0,0,0-22,48.49622v1.50061Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 483.99993,
    y: 433.13421,
    width: 22,
    height: 73,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 546.49993,
    cy: 517.13366,
    r: 13,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 119.3898,
    y: 392.36766,
    width: 17.26729,
    height: 57.29601,
    fill: "#f2f2f2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 141.36635,
    y: 392.36766,
    width: 57.29601,
    height: 57.29601,
    fill: "#f2f2f2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 203.37162,
    y: 392.36766,
    width: 17.26729,
    height: 57.29601,
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M361.87162,437.23035h17.26729v-1.17779A50.49022,50.49022,0,0,0,361.87162,397.989Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 141.36635,
    y: 454.37293,
    width: 57.29601,
    height: 51.80144,
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M295.15709,503.94488H277.8898v39.24341a12.55809,12.55809,0,0,0,12.558,12.558h4.70926Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M361.87162,503.94488v51.80143h4.70926a12.55785,12.55785,0,0,0,12.558-12.558V503.94488Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M295.15709,437.23035V397.989a50.49157,50.49157,0,0,0-17.26729,38.06356v1.17779Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M299.86635,437.23035h57.296V394.31808a50.37918,50.37918,0,0,0-28.648-8.89h0a50.381,50.381,0,0,0-28.648,8.89Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M401.69032,562.00679H255.70324a3.53587,3.53587,0,0,1-3.53195-3.532v-9.41852a3.53586,3.53586,0,0,1,3.53195-3.53194H401.69032a3.53586,3.53586,0,0,1,3.53194,3.53194v9.41852A3.53587,3.53587,0,0,1,401.69032,562.00679Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 662.3898,
    y: 392.36766,
    width: 17.26729,
    height: 57.29601,
    fill: "#f2f2f2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 684.36635,
    y: 392.36766,
    width: 57.29601,
    height: 57.29601,
    fill: "#f2f2f2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 746.37162,
    y: 392.36766,
    width: 17.26729,
    height: 57.29601,
    fill: "#f2f2f2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M904.87162,437.23035h17.26729v-1.17779A50.49022,50.49022,0,0,0,904.87162,397.989Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 684.36635,
    y: 454.37293,
    width: 57.29601,
    height: 51.80144,
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M838.15709,503.94488H820.8898v39.24341a12.55809,12.55809,0,0,0,12.558,12.558h4.70926Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M904.87162,503.94488v51.80143h4.70926a12.55785,12.55785,0,0,0,12.558-12.558V503.94488Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M838.15709,437.23035V397.989a50.49157,50.49157,0,0,0-17.26729,38.06356v1.17779Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M842.86635,437.23035h57.296V394.31808a50.37918,50.37918,0,0,0-28.648-8.89h0a50.381,50.381,0,0,0-28.648,8.89Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#f2f2f2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M944.69032,562.00679H798.70324a3.53587,3.53587,0,0,1-3.532-3.532v-9.41852a3.53586,3.53586,0,0,1,3.532-3.53194H944.69032a3.53586,3.53586,0,0,1,3.53194,3.53194v9.41852A3.53587,3.53587,0,0,1,944.69032,562.00679Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M988,752.42805H212a33.03734,33.03734,0,0,1-33-33v-503a33.03734,33.03734,0,0,1,33-33H988a33.03734,33.03734,0,0,1,33,33v503A33.03734,33.03734,0,0,1,988,752.42805Zm-776-567a31.0352,31.0352,0,0,0-31,31v503a31.0352,31.0352,0,0,0,31,31H988a31.0352,31.0352,0,0,0,31-31v-503a31.0352,31.0352,0,0,0-31-31Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M191.54834,249.19758a33.07366,33.07366,0,0,1-5.29663-65.71631L591.80615,50.2303a49.16464,49.16464,0,0,1,15.91846-.01953l406.094,133.29248a33.06684,33.06684,0,0,1-10.70068,65.2622c-4.37476-.625-399.522-57.04638-403.126-57.19482-3.5896.14844-399.12182,56.625-403.1167,57.1958A33.13819,33.13819,0,0,1,191.54834,249.19758Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M773.9355,672.97786a9.377,9.377,0,0,0-3.0996-14.0404l1.85337-21.34769L759.991,633.29941l-2.19391,30.18384a9.42779,9.42779,0,0,0,16.13837,9.49461Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#ffb8b8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "678.804 789.38 667.371 789.379 661.935 745.283 678.808 745.284 678.804 789.38",
    fill: "#ffb8b8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M659.20514,786.11233H681.253a0,0,0,0,1,0,0v13.88195a0,0,0,0,1,0,0H645.32321a0,0,0,0,1,0,0v0A13.88193,13.88193,0,0,1,659.20514,786.11233Z",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "652.853 760.12 641.751 762.848 625.945 721.325 642.331 717.299 652.853 760.12",
    fill: "#ffb8b8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M793.08,810.0222H815.1278a0,0,0,0,1,0,0v13.88195a0,0,0,0,1,0,0H779.19805a0,0,0,0,1,0,0v0A13.88193,13.88193,0,0,1,793.08,810.0222Z",
    transform: "translate(-330.4181 164.24985) rotate(-13.80529)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M823.92261,824.89387a4.2095,4.2095,0,0,1-4.1958-3.77881L806.57129,698.56184,795.124,736.03743l16.21363,58.53271a4.226,4.226,0,0,1-2.50562,5.05664l-12.88965,5.15576a4.23,4.23,0,0,1-5.56543-2.53515l-19.87036-57.00928a51.60425,51.60425,0,0,1-2.83545-19.395l2.77368-61.52344,73.04248,3.09278-1.14038,152.21435a4.25464,4.25464,0,0,1-3.91186,4.18652l-14.18457,1.06836C824.14062,824.89,824.031,824.89387,823.92261,824.89387Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 653.32609,
    cy: 454.0314,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M829.88794,671.41487c-6.46826,0-14.5044-.5293-22.81714-1.07617-11.36035-.74756-23.10718-1.52-31.875-1.0127a6.96733,6.96733,0,0,1-6.23169-2.71387c-9.03931-11.57373,4.90308-56.70752,5.501-58.623l11.34643-50.46827.4878.10987-.4878-.10987c2.49585-11.0996,10.471-19.28759,20.813-21.36816,9.67945-1.94482,19.043,1.93115,25.04785,10.375q.47791.67163.95557,1.37891c19.55176,28.95654,8.49316,100.896,7.75195,105.53906,1.03272,1.23682,6.61792,8.23193,5.08252,13.09082-.62427,1.97656-2.3208,3.32373-5.04223,4.00391A47.0065,47.0065,0,0,1,829.88794,671.41487Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#ccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M775.592,671.43782c-2.22461,0-5.22534-.8208-9.27222-2.50489-1.739-.72363-7.03076-2.92578-.60644-59.07226,3.15576-27.57959,7.67651-54.96729,7.72192-55.24072l.04346-.26368.24365-.11035c.11646-.05273,11.66187-5.3457,13.66968-12.146q.10473-.35376.23389-.68457a6.24331,6.24331,0,0,1,7.75366-3.8086A6.561,6.561,0,0,1,800.322,545.095a46.032,46.032,0,0,1-3.99048,12.79151c-5.4331,11.21-9.11352,40.92773-9.15014,41.22656-.20752,2.53809-5.13868,62.67187-6.08838,67.23535-.33179,1.59375-.94239,3.54443-2.73389,4.49024A5.84118,5.84118,0,0,1,775.592,671.43782Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M802.42383,669.13313a2.01917,2.01917,0,0,1-1.239-.42529c-7.22583-5.49121,4.46827-72.05176,11.40455-95.01612,1.38867-4.59814,2.62548-8.53662,3.676-11.70605h0a89.26716,89.26716,0,0,0,3.98926-17.50635c.38159-3.22559,1.21142-5.06787,2.53735-5.63281.92114-.39258,2.0044-.126,3.21948.79346,6.40552-.31495,12.63135,2.30175,18.40186,5.18115l5.19165,2.59082,5.82617,103.14892c-.16455,6.58252-13.14111,11.23-18.80395,11.52735-9.08814.47607-25.40845,1.95556-32.6001,6.50879A3.00535,3.00535,0,0,1,802.42383,669.13313Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M769.96582,649.77961c-.08569,0-.17163-.00244-.25806-.00781l-11.76733-.72412a4.22971,4.22971,0,0,1-3.92285-4.85352l5.325-35.27832,10.02441-49.49755a8.87931,8.87931,0,0,1,11.36182-6.70948h0a8.92789,8.92789,0,0,1,6.10742,9.8794l-7.96411,49.59668-4.7146,33.94677A4.25134,4.25134,0,0,1,769.96582,649.77961Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M816.31292,527.56047a26.205,26.205,0,1,0-4.91018-51.82531c-5.40118-3.27952-11.6809-5.48627-17.97478-4.925s-12.51835,4.29789-14.87192,10.16208.17487,13.59411,6.02708,15.9773c3.75184,1.52787,7.98866.78692,11.99255.17081s8.37171-1.01818,11.85635,1.04773,5.05106,7.60548,1.93025,10.18835a10.73848,10.73848,0,0,0-3.0842,11.82027C808.84653,524.233,813.12743,527.49165,816.31292,527.56047Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M761.87,529.75089a24.14567,24.14567,0,0,0-.00019,48.29133H761.87a24.14567,24.14567,0,0,0,0-48.29133Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#50a6e0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "e2b03078-4341-40c6-aa5e-abce84ce68da-991",
    "data-name": "Path 395",
    d: "M759.579,563.92441a2.93038,2.93038,0,0,1-1.76293-.58589l-.03153-.02366-6.64008-5.07944a2.9508,2.9508,0,1,1,3.59066-4.6836L759.036,556.85l10.16328-13.25912a2.94957,2.94957,0,0,1,4.13542-.54623l.00085.00064-.06307.08758.06478-.08758a2.95311,2.95311,0,0,1,.54559,4.13625l-11.95423,15.58866a2.95134,2.95134,0,0,1-2.347,1.15076Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M812.73362,596.70561H727.98906a8.57943,8.57943,0,0,0-8.58173,8.58173V690.0319a8.57943,8.57943,0,0,0,8.58173,8.58173h84.74456a8.57943,8.57943,0,0,0,8.58173-8.58173V605.28734A8.57943,8.57943,0,0,0,812.73362,596.70561Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#50a6e0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M793.64787,660.07438l-40.0116,7.79174a9.12829,9.12829,0,0,1-10.69285-7.20707L739.86774,644.865a9.12827,9.12827,0,0,1,7.20707-10.69285l40.0116-7.79174a9.12829,9.12829,0,0,1,10.69285,7.20708l3.07568,15.794A9.12827,9.12827,0,0,1,793.64787,660.07438Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M785.64278,641.41523l-30.53517,5.94633a2.14543,2.14543,0,0,1-.82018-4.21175l30.53516-5.94632a2.14543,2.14543,0,1,1,.82019,4.21174Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#50a6e0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M779.70754,650.22111l-15.794,3.07569a2.14543,2.14543,0,0,1-.82019-4.21175l15.79406-3.07569a2.14543,2.14543,0,0,1,.82018,4.21175Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#50a6e0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M821.31535,605.28734v11.26352h-101.908V605.28734a8.57943,8.57943,0,0,1,8.58173-8.58173h84.74456A8.57943,8.57943,0,0,1,821.31535,605.28734Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#3f3d56"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M810.16851,611.16439a9.377,9.377,0,0,1,14.22529-2.09316l19.295-9.32,8.52354,10.34415-27.43314,12.77888a9.42779,9.42779,0,0,1-14.6107-11.70992Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#ffb8b8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M836.97168,621.17366a4.23283,4.23283,0,0,1-4.11426-3.24121l-2.803-11.64991a4.21319,4.21319,0,0,1,1.94019-4.61963l16.9021-10.11523-8.63989-31.63428a10.82127,10.82127,0,0,1,.3789-6.80078h.00025a10.75332,10.75332,0,0,1,20.21386.62061l9.53882,29.125a17.57668,17.57668,0,0,1-6.4209,19.77343L839.44922,620.37A4.22473,4.22473,0,0,1,836.97168,621.17366Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#2f2e41"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M864.9015,850.42805h-102a1,1,0,1,1,0-2h102a1,1,0,0,1,0,2Z",
    transform: "translate(-158.5 -49.57195)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.979d89402404718001c5fad10cc9a27d.svg";
export { ForwardRef as ReactComponent };